module.exports = __webpack_public_path__ + "assets/bg-ico-hero.b5c826fc619edc4cc35993d0cd3c827c.jpg";